export default __webpack_public_path__ + "fonts/sketch_img.73021bbde8d014bf544ab9ae2cb5485a.png";